import { render } from "./Viewer.vue?vue&type=template&id=9ef04e96&scoped=true"
import script from "./Viewer.vue?vue&type=script&lang=js"
export * from "./Viewer.vue?vue&type=script&lang=js"

import "./Viewer.vue?vue&type=style&index=0&id=9ef04e96&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1003992750/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ef04e96"]])

export default __exports__